module.exports = __webpack_public_path__ + "img/exh-image01.bd23c8dd.jpg";